module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"labelFieldTitle":"Ajouter des crédits","creditNumber":"Nombre de crédits","btnCancel":"Annuler","btnSave":"Enregistrer"},"en":{"labelFieldTitle":"Add credits","creditNumber":"Credit number","btnCancel":"Cancel","btnSave":"Save"}}')
  delete Component.options._Ctor
}
